import { FunctionComponent } from 'react';
import { Switch, Route } from 'react-router-dom';

import AccountsList from './AccountsList';
import AccountContainer from './Account/AccountContainer';
import SubAccountContainer from './SubAccounts/SubAccountContainer';
import AccountCreation from './AccountCreation/AccountCreationContainer';

import BillingPackageDetails from '../BillingPackages/BillingPackageDetails';

import { BillingDetailsProvider } from '../../providers/BillingDetails.provider';

import type { AccountsHandlers } from './types';
import { PendingDataProvider } from '../../providers/PendingData.provider';

import Transaction from '../Transaction/Transaction';
import SignerDetailsContainer from './Signers/SignerDetails/SignerDetailsContainer';
import AddSignercontainer from './Signers/Addsigner/AddSignerContainer';
import EditSignerContainer from './Signers/EditSigner/EditSignerContainer';

type RoutesProps = {
  handlers: AccountsHandlers;
};

type FC = FunctionComponent<RoutesProps>;

const Routes: FC = ({ handlers }: RoutesProps) => (
  <Switch>
    <Route path="/accounts" exact>
      <AccountsList onRouteAccess={handlers.resetAccountsState} exportCSV={handlers.exportCSV} />
    </Route>
    <Route path="/accounts-create">
      <PendingDataProvider>
        <AccountCreation handlers={handlers} />
      </PendingDataProvider>
    </Route>
    <Route path="/accounts/signer-create" exact>
      <PendingDataProvider>
        <AddSignercontainer />
      </PendingDataProvider>
    </Route>
    <Route path="/accounts/:accountId/view/:SigningAuthorityID" exact>
      <SignerDetailsContainer />
    </Route>
    <Route path="/accounts/:accountId/edit/:SigningAuthorityID" exact>
      <EditSignerContainer />
    </Route>
    <Route path="/accounts/:accountId/:transType/transaction/:TransactionID">
      <Transaction />
    </Route>
    <Route path="/accounts/create">
      <PendingDataProvider>
        <AccountCreation handlers={handlers} />
      </PendingDataProvider>
    </Route>
    <Route path="/accounts/billing/:resource/:id">
      <BillingDetailsProvider>
        <BillingPackageDetails />
      </BillingDetailsProvider>
    </Route>
    <Route path="/accounts/sub-account/:accountId">
      <SubAccountContainer handlers={handlers} />
    </Route>
    <Route path="/accounts/:accountId">
      <AccountContainer handlers={handlers} />
    </Route>
  </Switch>
);

export default Routes;
